import { Button, Dialog, DialogActions, MenuItem, Stack, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import ModalHeader from '../../components/ModalHeader';
import { useSelector } from 'react-redux';
import FormSelectField from '../../components/FormSelectField';
import { Formik, Form } from 'formik';
import { useTheme } from '@emotion/react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import appapi from '../../api/apiClient';
import { useTranslation } from 'react-i18next';

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '528px',
    margin: '8px',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100% - 20px)',
  },
};

export default function CreateUnionRegistryAccount({ modalOpen = true, onModelHandleClose }) {
  // const { countryList } = useSelector((state) => state.layout);
  const [countryList, setCountryList] = useState([]);
  const { t } = useTranslation();
  const formRef = useRef();
  const theme = useTheme();

  const getCountryList = async () => {
    const response = await appapi.get(`common/euRegistryList/`);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setCountryList(data.response || []);
      } else {
        setCountryList([]);
      }
    }
  };

  useEffect(() => {
    getCountryList();
  }, []);

  return (
    <Dialog
      sx={sx}
      open={modalOpen}
    >
      <Stack>
        <ModalHeader
          label={t('Create New Union Registry Account')}
          onClose={() => onModelHandleClose(false)}
        />
        <Stack
          style={{ backgroundColor: '#8993AC26', width: '100%', height: '2px' }}
          className=""
        />
        <Formik
          innerRef={formRef}
          enableReinitialize={false}
          initialValues={{}}
          onSubmit={(values) => {}}
        >
          {({ name, values, touched, errors, setFieldValue }) => (
            <Form autoComplete="off">
              <Stack
                style={{}}
                className="mx-[16px] mt-[16px] mb-[24px]"
              >
                <Stack>
                  <FormSelectField
                    name="country"
                    label={`${t('Country')} *`}
                    onSelect={(e) => {
                      //   setFieldValue('stateName', undefined);
                    }}
                  >
                    {countryList?.map((item) => (
                      <MenuItem
                        key={item.country}
                        value={item.country}
                      >
                        <div style={{ textTransform: 'capitalize' }}>{item.country}</div>
                      </MenuItem>
                    ))}
                  </FormSelectField>
                </Stack>
                {values?.country ? (
                  <>
                    <a
                      href={countryList?.filter((res) => res.country == values?.country)[0]?.link}
                      style={{ width: '100%', height: '40px', backgroundColor: '#003399', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row', display: 'flex', padding: '16px', borderRadius: '4px' }}
                      target="blank"
                    >
                      <Stack>
                        {' '}
                        <Typography
                          className="fs-14 ff-Roboto fw-medium"
                          color={'#FFFFFF'}
                        >
                          {t('Go to the link')}
                        </Typography>
                      </Stack>
                      <Stack>
                        {' '}
                        <ArrowForwardIcon color="white" />
                      </Stack>
                    </a>
                  </>
                ) : (
                  <Stack
                    style={{ width: '100%', height: '40px', backgroundColor: '#14285A1A', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row', display: 'flex', padding: '16px', borderRadius: '4px' }}
                    disable={true}
                  >
                    <Stack>
                      {' '}
                      <Typography
                        className="fs-14 ff-Roboto fw-medium"
                        color={'#14285A80'}
                      >
                        {t('Go to the link')}
                      </Typography>
                    </Stack>
                    <Stack>
                      {' '}
                      <ArrowForwardIcon color={'#14285A80'} />
                    </Stack>
                  </Stack>
                )}
              </Stack>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
